import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

export type ButtonVariant = 'default' | 'primary' | 'danger' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  /** Optional leading icon/emoji. */
  icon?: ReactNode;
}

const variantClass: Record<ButtonVariant, string | undefined> = {
  default: undefined,
  primary: styles.primary,
  danger: styles.danger,
  ghost: styles.ghost,
};

export function Button({
  variant = 'default',
  size = 'md',
  block = false,
  icon,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [
    styles.btn,
    styles[size],
    variantClass[variant],
    block ? styles.block : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {icon != null && <span aria-hidden>{icon}</span>}
      {children}
    </button>
  );
}
